<template>
  <el-form ref="form" :model="{}" label-width="140px" :rules="rules">
    <el-form-item label="计划组预算" prop="dailyBudget">
      <RadioGroup v-model="outterForm.budget" type="button" @on-change="outterForm.day_budget = ''">
        <Radio label="NONE" :disabled="outterForm.speed === 3">不限</Radio>
        <Radio label="BUDGET" :disabled="campaignBidMaxConversion">日预算</Radio>
      </RadioGroup>

      <div style="margin-top: 10px" v-if="outterForm.budget === 'BUDGET'">
        <Input
          v-model="outterForm.day_budget"
          placeholder="每日预算范围 100~100,000,000元"
          style="width: 237px"
          @on-blur="inputTrim('day_budget', outterForm.day_budget, outterForm, true)"
        >
          <span slot="append" style="padding: 0 6px"> 元 </span>
        </Input>
      </div>
    </el-form-item>

    <el-form-item label="投放方式">
      <RadioGroup v-model="outterForm.speed" type="button">
        <Radio :label="1">加速投放</Radio>
      </RadioGroup>
    </el-form-item>

    <el-form-item label="投放时间">
      <RadioGroup v-model="outterForm.dateRange" type="button">
        <Radio label="NONE">从今天起长期投放</Radio>
        <Radio label="RANGE">设置开始和结束日期</Radio>
      </RadioGroup>
    </el-form-item>

    <el-form-item prop="bidTimeRange" v-if="outterForm.dateRange === 'RANGE'">
      <DatePicker
        type="date"
        :value="outterForm.begin_time"
        placeholder="请选择开始日期"
        style="width: 160px"
        :options="{ disabledDate: startOption }"
        @on-change="changeStartTime"
      ></DatePicker>
      <span class="split-line"> —— </span>
      <DatePicker
        type="date"
        :value="outterForm.end_time"
        placeholder="请选择结束日期"
        style="width: 160px"
        :options="{ disabledDate: endOption }"
        @on-change="changeEndTime"
      ></DatePicker>
    </el-form-item>

    <el-form-item label="投放时段">
      <RadioGroup v-model="outterForm.timeRange" type="button">
        <Radio label="NONE">不限</Radio>
        <Radio label="RANGE">指定时间段</Radio>
      </RadioGroup>
      <div style="margin-top: 10px" v-if="outterForm.timeRange === 'RANGE'">
        <drag-weektime v-model="outterForm.schedule_time" :colspan="1" :data="weektimeData" />
      </div>
    </el-form-item>

    <el-form-item label="创意展现方式">
      <RadioGroup v-model="outterForm.show_mode" type="button">
        <Radio :label="2">智能优选</Radio>
        <Radio :label="1">随机轮播</Radio>
      </RadioGroup>
    </el-form-item>
    <el-form-item label="优化目标" v-if="innerForm.promoted_type === 1">
      <RadioGroup v-model="outterForm.ocpx_action_type" @on-change="changeConversion" type="button">
        <Radio :label="634">预约表单</Radio>
        <Radio :label="635">预约点击跳转</Radio>
      </RadioGroup>
      <span v-if="formData.batch_task_type === 1 && campaignBidMaxConversion">
        <span style="color: #ff4400; margin-top: 6px; display: block">
          提示：请注意同一个推广计划下面，只能建同一个优化目标类型的计划组，否则建计划会报错。
        </span>
      </span>
    </el-form-item>
    <el-form-item label="优化目标" v-else>
      <RadioGroup v-model="outterForm.ocpx_action_type" @on-change="changeConversion" type="button">
        <Radio :label="2">行为数</Radio>
        <Radio :label="180">激活</Radio>
        <Radio :label="190">付费</Radio>
        <Radio :label="739">7日付费次数</Radio>
        <Radio :label="191">首日ROI</Radio>
        <Radio :label="774">7日ROI</Radio>
      </RadioGroup>
    </el-form-item>
    <el-form-item label="计费类型">
      <RadioGroup v-model="outterForm.bid_type" type="button">
        <Radio :label="10" :disabled="campaignBidMaxConversion">OCPM</Radio>
        <Radio :label="12" :disabled="campaignBidOcpm">最大转化</Radio>
      </RadioGroup>
    </el-form-item>

    <!-- 如果是  ROI转化 和 OCPM计费类型 -->
    <template v-if="!roiConversion && campaignBidOcpm">
      <el-form-item label="目标出价">
        <RadioGroup v-model="outterForm.bid_range" type="button" @on-change="changeBidRange">
          <Radio :label="0">固定金额</Radio>
          <Radio :label="1">随机金额</Radio>
        </RadioGroup>
      </el-form-item>

      <el-form-item v-if="outterForm.bid_range" prop="bid_num_range">
        <InputRange v-model="outterForm.bid_num_range" placeholder="输入金额">
          <span slot="suffix">元</span>
        </InputRange>
      </el-form-item>

      <el-form-item prop="cpa_bid" v-else>
        <Input
          v-model="outterForm.cpa_bid"
          placeholder="请输入出价"
          style="width: 237px"
          @on-blur="inputTrim('cpa_bid', outterForm.cpa_bid, outterForm, true)"
        >
          <span slot="append" style="padding: 0 6px"> 元 </span>
        </Input>
      </el-form-item>
    </template>
    <!-- 优化目标 = [180激活, 190付费] 时显示 -->
    <el-form-item label="深度转化目标" v-show="deepConversion && campaignBidOcpm">
      <Select
        v-model="outterForm.deep_conversion_type"
        placeholder="请选择深度转化目标"
        transfer
        style="width: 358px"
        @on-change="changeDeepConver"
      >
        <Option :value="0" label="无" :disabled="outterForm.speed === 3" />
        <!-- conversionList
            { "id": 3, "value": "付费" },
            { "id": 92, "value": "首日ROI" }
           -->
        <Option v-for="deep in conversionList" :key="deep.id" :value="deep.id" :label="deep.value" :disabled="outterForm.speed === 3" />
      </Select>
    </el-form-item>

    <!-- 深度转化目标 为付费的时候显示 深度转化目标出价-->
    <template v-if="deepConversion && [3].includes(outterForm.deep_conversion_type)">
      <el-form-item label="深度转化目标出价" v-show="campaignBidOcpm">
        <RadioGroup v-model="outterForm.deep_bid_range" type="button" @on-change="changeDeepCpabidRange">
          <Radio :label="0">固定金额</Radio>
          <Radio :label="1">随机金额</Radio>
        </RadioGroup>
      </el-form-item>

      <el-form-item v-if="outterForm.deep_bid_range" prop="deep_deepbid_num_range">
        <InputRange v-model="outterForm.deep_deepbid_num_range" placeholder="输入金额">
          <span slot="suffix">元</span>
        </InputRange>
      </el-form-item>

      <el-form-item v-else prop="deep_conversion_bid">
        <Input
          v-model="outterForm.deep_conversion_bid"
          placeholder="出价范围 1~10,000元,须大于目标出价小于组预算"
          style="width: 237px"
          @on-blur="inputTrim('deep_conversion_bid', outterForm.deep_conversion_bid, outterForm, true)"
        >
          <span slot="append" style="padding: 0 6px"> 元 </span>
        </Input>
      </el-form-item>
    </template>
    <!-- 深度转化目标为首日ROI[deep_conversion_type = 92]的时候显示 ROI系数-->
    <template v-if="isROI">
      <el-form-item label="ROI系数" v-if="campaignBidOcpm">
        <RadioGroup v-model="outterForm.roi_range" type="button">
          <Radio :label="0">固定ROI系数</Radio>
          <Radio :label="1">随机ROI系数</Radio>
        </RadioGroup>
      </el-form-item>

      <template v-if="campaignBidOcpm">
        <el-form-item v-if="outterForm.roi_range" prop="roi_ratio_range">
          <InputRange v-model="outterForm.roi_ratio_range" placeholder="ROI系数">
            <span slot="suffix">元</span>
          </InputRange>
        </el-form-item>
        <el-form-item v-else prop="roi_ratio">
          <input-number-plus
            v-model="outterForm.roi_ratio"
            :max="3"
            :min="0.001"
            :step="0.001"
            :precision="3"
            :width="237"
            placeholder="请输入系数，范围: 0.001 ~ 100 "
          />
          <span style="padding: 0 6px"> 元 </span>
        </el-form-item>
      </template>
    </template>
  </el-form>
</template>
<script>
import { isEmpty, trim, getTime } from '@/common/js/utils'

import conversionData from '@/data/kuaishou/conversion_type.json'
import DragWeektime from './components/time-range/index.vue'
import weektimeData from '@/data/kuaishou/weektime_data'
import InputRange from './components/input-range/index.vue'
import InputNumberPlus from '@/components/input/input-number-plus'
import { makeBudgetRules } from './data/form-rules.js'
export default {
  components: { DragWeektime, InputRange, InputNumberPlus },
  computed: {
    formData() {
      return this.$store.getters['Kuaishou/currTaskParams']
    },

    outterForm: {
      get() {
        return this.formData.outterForm
      },
      set(v) {
        this.$store.commit('Kuaishou/UPDATE_OUT_PARAMS', v)
      }
    },
    innerForm() {
      return this.formData.innerForm
    },
    isROI() {
      return this.roiConversion || this.outterForm.deep_conversion_type === 92
    },
    startOption() {
      return (date) => {
        return date && (date.valueOf() < Date.now() - 86400000 || date.valueOf() > getTime(this.outterForm.end_time))
      }
    },
    endOption() {
      return (date) => {
        return date && date.valueOf() < getTime(this.outterForm.begin_time)
      }
    },
    roiConversion() {
      return [191, 774].includes(this.outterForm.ocpx_action_type)
    },
    conversionList() {
      if (this.outterForm.ocpx_action_type === 190) {
        return this.conversionData.filter((ret) => ret.id !== 3)
      }
      return this.conversionData
    },
    deepConversion() {
      return [180, 190].includes(this.outterForm.ocpx_action_type)
    },
    // 广告组投放场景 [0常规投放 | 1最大转化投放]
    bidType() {
      return this.outterForm.bid_type === 12 ? 1 : 0
    },
    // 常规投放
    campaignBidOcpm() {
      return this.bidType === 0
    },
    // 最大转化投放
    campaignBidMaxConversion() {
      return this.bidType === 1
    }
  },
  data() {
    return {
      rules: { ...makeBudgetRules.call(this) },
      media: Number(this.$store.state.Kuaishoulocal.media),
      timeRange: 'NONE',
      weektimeData,
      conversionData
    }
  },
  methods: {
    inputTrim(key, val, obj, fixed) {
      if (isEmpty(val)) return val
      val = trim(val)
      if (fixed) {
        val = parseFloat(val) * 1000
        val = Math.floor(val) / 1000
      } else val = parseInt(val)
      obj[key] = isEmpty(val) ? 0 : val
    },
    // 投放时间
    changeStartTime(val) {
      const outterForm = Object.assign({}, this.outterForm)
      const start = getTime(val)
      const end = getTime(outterForm.end_time)
      if (end < start) outterForm.end_time = val
      outterForm.begin_time = val
      this.outterForm = outterForm
    },
    changeEndTime(val) {
      const outterForm = Object.assign({}, this.outterForm)
      outterForm.end_time = val
      this.outterForm = outterForm
    },
    changeConversion() {
      const outterForm = Object.assign({}, this.outterForm)
      if (this.isROI) outterForm.cpa_bid = 0
      else outterForm.roi_ratio = undefined
      if (!this.deepConversion) {
        outterForm.deep_conversion_type = 0
        outterForm.deep_conversion_bid = undefined
      }
      this.outterForm = outterForm
    },

    // 切换随机出价
    changeBidRange(val) {
      if (val) {
        const outterForm = Object.assign({}, this.outterForm)
        this.$set(outterForm, 'bid_num_range', ['', ''])
        this.$set(outterForm, 'cpa_bid', '')
        this.outterForm = outterForm
      }

      // 清空校验
      this.$refs.form.clearValidate(['bid_num_range', 'cpa_bid'])
    },
    changeDeepConver(val) {
      const outterForm = Object.assign({}, this.outterForm)
      if (val === 3) {
        outterForm.deep_conversion_bid = ''
      } else {
        outterForm.deep_conversion_bid = undefined
      }
      this.outterForm = outterForm
    },
    changeDeepCpabidRange(val) {
      if (val) {
        const outterForm = Object.assign({}, this.outterForm)
        outterForm.deep_deepbid_num_range = ['', '']
        outterForm.deep_conversion_bid = ''
        this.outterForm = outterForm
      }
    },
    /**
     * @description: 表单校验
     * @return {*} 成功promise.resolve 失败promise.reject
     */
    formValidate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject(new Error('budget'))
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped></style>
